import { usePortalConnectionByIndex } from 'bones/utils/portal/usePortalConnectionByIndex';
import { getStardogConnection } from 'bones/utils/request/getStardogConnection';

export const useStardogConnectionFromPortalIndex = (connectionIdx: number) => {
  const connection = usePortalConnectionByIndex(connectionIdx);
  const stardogConnection = connection.data?.token
    ? getStardogConnection({
        endpoint: connection.data.endpoint,
        username: connection.data.username || '',
        token: connection.data.token,
      })
    : null;
  return stardogConnection;
};
